// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"c845bbbb","604":"963c42f7"}[chunkId] + ".chunk.js";
};